import { authHeader, header } from "helpers/header";
import { handleResponse } from "helpers/handleResponse";
import { store } from "../../store/store"
const apiurl = process.env.REACT_APP_API_URL;

export const homeServices = {
  getPlaceDetail,
  getPlaceNameFromSearch,
  writeErrorLog
};

// get place detail based on use logout or login
function getPlaceDetail(token) {
  let enterprise = store.getState().global;
  if(token){
    const requestOption = {
      method: "GET",
      headers: authHeader(),
    };
  
    return fetch(apiurl + `api/places?enterpriseName=${enterprise?.baseName?.split("/")[1].replace(/-/g, " ")}&isFavourite=true`, requestOption)
      .then(handleResponse)
      .then((data) => {
        return data.data;
      })
      .catch((error) => {
        return {
          status: error?.status,
          data: {},
          error: error?.message || "Failed to fetch",
        };
      });
  }
  else{
    const requestOption = {
      method: "GET",
      headers: header(),
    };
  
    return fetch(apiurl + `api/places?enterpriseName=${enterprise?.baseName?.split("/")[1].replace(/-/g, " ")}`, requestOption)
      .then(handleResponse)
      .then((data) => {
        return data.data;
      })
      .catch((error) => {
        return {
          status: error?.status,
          data: {},
          error: error?.message || "Failed to fetch",
        };
      });
  }
}

function getPlaceNameFromSearch(searchText){
  const requestOption = {
    method: "GET",
    headers: header(),
  };

  return fetch(apiurl + `api/places?q=${searchText}`, requestOption)
    .then(handleResponse)
    .then((data) => {
      return data.data;
    })
    .catch((error) => {
      return {
        status: error?.status,
        data: {},
        error: error?.message || "Failed to fetch",
      };
    });
}

function writeErrorLog(reqPram){
  var token = localStorage.getItem("BearerToken") !== null ? JSON.parse(localStorage.getItem("BearerToken") || "") : null;
  const requestOptions = {
    method: 'POST',
    headers: authHeader(token),
    body: JSON.stringify(reqPram)
  };

  return fetch(apiurl + `api/post-log`, requestOptions)
    .then(handleResponse)
    .then((data) => {
      return data.data;
    })
    .catch((error) => {
      return {
        status: error?.status,
        data: {},
        error: error?.message || "Failed to fetch",
      };
    });
}
